import { Dashboard } from '../components/Dashboard';

import { declickables, Declickables } from 'components/Declickables';
import { Request } from 'components/Request';
import { clearInlineError, showInlineError } from 'components/inlineFeedback';
import { showToast } from 'react/toasts/showToast';
import { Users } from 'models/UserCollection';
import { User } from 'models/User';

import React from 'react';

import { MatchHistory } from './MatchHistory';
import { ChatRoom } from '../models/ChatRoom';
import store from '../react/redux/store/store';
import * as popupActions from '../react/redux/actions/popups';
import PopupTypes from './PopupTypes';

class UserInfo {

	constructor(infoContainer) {
		this.infoContainer = infoContainer;
		this.currentUser = null;
		this.currentData = {};
		this.lastPosition = { x: 0, y: 0 };

		this.lastChatRoom = null;

		this.isLoading = false;

		this.matchHistoryClick = this.matchHistoryClick.bind(this);
		this.reloadProfile = this.reloadProfile.bind(this);
		this.keepOnScreen = () => {
		};
	}

	reloadProfile() {
		return this.loadProfile(this.currentUser, this.lastPosition);
	}

	resetLastPositionFunction() {
		this.keepOnScreen = _.once(Dashboard.keepContainerOnScreen.bind(null, this.infoContainer, this.lastPosition));
	}

	async loadProfile(requestData, position) {
		let user = null;
		if(position) {
			if(position.nativeEvent) {
				position = position.nativeEvent;
			}
			if(position.pageX) {
				position = {
					x: position.pageX,
					y: position.pageY
				};
			}
		}
		if(position) {
			this.lastPosition = position;
		}
		this.requestData = requestData;
		let infoContainer = this.infoContainer;
		this.resetLastPositionFunction();

		if(requestData instanceof User) {
			user = requestData;
			requestData = this.requestData = {
				id: user.id
			};
		}
		else {
			if(requestData.id) {
				user = Users.retrieveById(requestData.id);
			}
			else if(requestData.username) {
				user = Users.retrieveByUsername(requestData.username);
			}
			else {
				console.error('loadProfile needs a User, an id or a username', requestData);
			}
		}

		if(requestData.chat_room_id) {
			this.lastChatRoom = requestData.chat_room_id;
		}
		else {

			const activeMainChat = ChatRoom.getActiveMainChat();
			if(activeMainChat) {
				requestData.chat_room_id = activeMainChat.id;
				this.lastChatRoom = activeMainChat.id;
			}
		}
		store.dispatch(popupActions.userClickPopupOpen(user, PopupTypes.PROFILE_CARD, position));
	}

	matchHistoryClick(e) {
		console.error('hm?');
		e.preventDefault();
		const player = this.currentUser;
		if(!player || !player.id) {
			return null;
		}
		declickables.closeDeclickables();
		MatchHistory.retrieveHistory({
			player: player
		});
	}

	static editFieldPopupSubmit(popup, form) {
		const inputs = form.find(':input');

		const data = {};
		inputs.each((i, input) => {
			input = $(input);
			if(input.attr('name') && data[input.attr('name')] === undefined) {
				data[input.attr('name')] = input.val();
			}
		});
		inputs.prop('disabled', true);
		const formElement = form[0];
		clearInlineError(formElement);
		return Request.post(form.attr('action'), data)
			.then((response) => {
				if(response.success) {
					popup.dismiss();
					showToast({ content: 'Changes saved' });
					return response;
				}
				showInlineError(formElement, response.error || 'There was an error');
			}).catch(function(error) {
				console.error(error);
				showInlineError(formElement, 'There was a server side error');
			}).finally(function() {
				inputs.prop('disabled', false);
			});
	}

	static openEditFieldPopup(field, successCallback = () => {
	}) {
		if(!field.isEditable()) {
			console.error('field is not editable');
			console.log(field);
			return;
		}
		const data = {
			field: field.type
		};
		declickables.closeDeclickables();
		const popup = Dashboard
			.ladderPopup(null, 'Edit ' + field.name, {
				buttons: [
					{
						dismiss: true,
						text: 'Cancel'
					},
					{
						text: 'Save',
						click: (popup) => {
							UserInfo.editFieldPopupSubmit(popup, popup.popup.find('form')).then((response) => {
								return successCallback(response);
							});
							// popup.popup.find('form').trigger('submit');
						}
					},
				]
			})
			.showLoader();
		Request.get(siteUrl + '/matchmaking/edit_game_specific_field', data).then(function(response) {
			const content = $(response.html);
			console.log('form content', content);
			popup.updateContent(content);
			const form = content.find('form');
			form.submit(function(e) {
				e.preventDefault();
			});
		});

		//TODO: Finish submission process so that match can update...

		return new Promise((success, reject) => {
			popup.onDismiss.then(() => {

			});
		});
	}
}

UserInfo.behaviorClasses = 'general active questionable toxic neutral good positive new';
UserInfo.displayStateClasses = 'game_select_mode';

export { UserInfo };